module.exports = __webpack_public_path__ + "static/media/hamburger-icon-white.898439e5.svg";